import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { AuthLayout } from '../../../shared/components/auth';
import MagicCodeLoginForm from '../components/MagicCodeLoginForm';
import { useMagicCodeLoginStore } from '../stores/magicCodeLoginStore';
import { Routes as AppRoutes } from '../../../routes';

const MagicLinkHandler: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { codeAttempts, setCurrentStep, setEmail, setCode, goToCodeStep } =
    useMagicCodeLoginStore();
  const navigate = useNavigate();

  const urlEmail = searchParams.get('email');
  const urlCode = searchParams.get('code');

  const handleLoginSuccess = () => {
    navigate(AppRoutes.sites.manage, { replace: true });
  };

  useEffect(() => {
    if (codeAttempts > 0) {
      return;
    }

    setCurrentStep('email');

    if (urlEmail) {
      setEmail(urlEmail);

      if (urlCode) {
        goToCodeStep();
        setCode(urlCode);
      }
    }
  }, [
    codeAttempts,
    urlEmail,
    urlCode,
    setCurrentStep,
    setEmail,
    setCode,
    goToCodeStep,
  ]);

  return (
    <AuthLayout variant="login">
      <MagicCodeLoginForm onLoginSuccess={handleLoginSuccess} />
    </AuthLayout>
  );
};

export default MagicLinkHandler;
